import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private isExpandedSubject = new BehaviorSubject<boolean>(false);
  isExpanded$ = this.isExpandedSubject.asObservable();

  toggleSidebar() {
    this.isExpandedSubject.next(!this.isExpandedSubject.value);
  }

  setSidebarState(expanded: boolean) {
    this.isExpandedSubject.next(expanded);
  }

  setExpanded(value: boolean) {
    this.isExpandedSubject.next(value);
  }
}
